import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { httpClient } from '../api/httpClient';

/**
 * Хук для обработки ошибок аутентификации
 * Автоматически перенаправляет на страницу логина при ошибках аутентификации
 * ТОЛЬКО в обычном браузере, НИКОГДА в Telegram
 */
export const useAuthError = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const handleAuthError = (error) => {
            console.log('🔐 Auth error in useAuthError hook:', error);

            // В Telegram среде НИКОГДА не перенаправляем на страницу логина
            const isTelegramEnvironment = !!window.Telegram?.WebApp;
            if (isTelegramEnvironment) {
                console.log('🔐 Telegram среда: редирект на авторизацию не требуется, ждём initData');
                return;
            }

            if (error.code === 'AUTH_REQUIRED') {
                // Перенаправляем на страницу логина только в обычном браузере
                console.log('🔐 Redirecting to login due to auth error (browser)');

                // Очищаем токен
                localStorage.removeItem('access_token');

                // Определяем путь для редиректа
                const currentPath = window.location.pathname;

                // Проверяем, не находимся ли мы уже на странице авторизации
                if (currentPath === '/auth') {
                    console.log('🔐 Уже на странице авторизации - редирект не нужен');
                    return;
                }

                navigate('/auth', { replace: true });
            }
        };

        // Регистрируем обработчик ошибок аутентификации
        httpClient.onAuthError(handleAuthError);

        // Очищаем при размонтировании
        return () => {
            httpClient.offAuthError(handleAuthError);
        };
    }, [navigate]);

    return null;
};
